import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Badge from 'react-bootstrap/Badge';
import { useMsal } from '@azure/msal-react';
import KarmaTextBooking from './KarmaTextBooking';
import SMSConversationManager from './SMSConversationManager';
import SMSTemplateBuilder from './SMSTemplateBuilder';
import SMSMessageAdmin from './SMSMessageAdmin';
import { isSmsAdminAccount } from '../utils/smsPermissions';

function SMSWorkspace() {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount() || instance.getAllAccounts?.()[0] || null;
  const isSmsAdmin = isSmsAdminAccount(activeAccount);

  // If a conversationId is in the URL (e.g. Teams deep-link), default to conversations tab.
  const hasConversationDeepLink = new URLSearchParams(window.location.search).has('conversationId');
  const defaultTab = hasConversationDeepLink ? 'conversations' : 'booking';

  return (
    <div className="row mb-2 mt-4">
      <div className="col-sm-10 offset-1">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 className="mb-0">SMS Workspace</h5>
          <Badge bg={isSmsAdmin ? 'success' : 'secondary'}>
            {isSmsAdmin ? 'Admin Mode' : 'Standard Mode'}
          </Badge>
        </div>
        <Tabs defaultActiveKey={defaultTab} id="sms-workspace-tabs" className="mb-3" justify>
          <Tab eventKey="booking" title="Booking">
            <KarmaTextBooking />
          </Tab>
          <Tab eventKey="conversations" title="Conversations">
            <SMSConversationManager />
          </Tab>
          {isSmsAdmin && (
            <Tab eventKey="templates" title="Templates">
              <SMSTemplateBuilder />
            </Tab>
          )}
          {isSmsAdmin && (
            <Tab eventKey="message-text" title="Message Text">
              <SMSMessageAdmin />
            </Tab>
          )}
        </Tabs>
      </div>
    </div>
  );
}

export default SMSWorkspace;
